import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'reports',
	loader: () => ({
		meta: {
			title: 'Reports',
			disabled: true,
			htmlTitlePattern: '#title :: Reports ',
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/reports/Layout')).default }),
	children: [
		{
			path: 'boi',
			index: true,
			id: 'boiReport',
			loader: () => ({
				meta: {
					title: 'BOI',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/reports/pages/BOI')).default }),
		},
		{
			path: 'boi/pnl',
			index: true,
			id: 'boiPnlReport',
			loader: () => ({
				meta: {
					title: 'BOI PNL',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/essentialDocuments/reports/pages/BoiPnL')).default }),
		},
	],
};
export default route;
